export const REGEX = {
  trailingSlash: /\/$/,
}
